import { useNavigate } from 'react-router-dom'
import { Home, ArrowLeft, RefreshCw, Clock } from 'lucide-react'

export function ServiceUnavailablePage() {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 via-white to-indigo-50 px-4">
      <div className="text-center max-w-2xl mx-auto">
        <div className="mb-8 relative">
          <div className="text-[180px] md:text-[220px] font-bold text-blue-200 leading-none select-none">
            503
          </div>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="text-6xl md:text-8xl">🔧</div>
          </div>
        </div>

        <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
          服务暂时不可用
        </h1>

        <p className="text-lg text-gray-600 mb-8 leading-relaxed">
          很抱歉，系统正在进行维护或升级。<br />
          请稍后再试，感谢您的耐心等待。
        </p>

        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-8 max-w-md mx-auto">
          <div className="flex items-start gap-3">
            <Clock className="text-blue-500 flex-shrink-0 mt-0.5" size={20} />
            <div className="text-left">
              <p className="text-sm font-medium text-blue-800 mb-1">错误代码：503</p>
              <p className="text-sm text-blue-700">
                服务维护中，预计恢复时间：30分钟
              </p>
            </div>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button
            onClick={() => navigate('/')}
            className="inline-flex items-center justify-center gap-2 px-8 py-3 bg-primary-500 text-white font-medium rounded-lg transition-all duration-300 hover:bg-primary-600 hover:shadow-lg hover:shadow-primary-500/25 active:scale-95"
          >
            <Home size={20} />
            返回首页
          </button>

          <button
            onClick={() => window.location.reload()}
            className="inline-flex items-center justify-center gap-2 px-8 py-3 bg-white text-primary-500 font-medium rounded-lg border-2 border-primary-500 transition-all duration-300 hover:bg-primary-50 active:scale-95"
          >
            <RefreshCw size={20} />
            刷新页面
          </button>

          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center justify-center gap-2 px-8 py-3 bg-gray-100 text-gray-700 font-medium rounded-lg transition-all duration-300 hover:bg-gray-200 active:scale-95"
          >
            <ArrowLeft size={20} />
            返回上一页
          </button>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-200">
          <p className="text-sm text-gray-500">
            紧急情况？请通过
            <a href="/cooperation" className="text-primary-500 hover:text-primary-600 mx-1">
              联系合作
            </a>
            页面联系我们
          </p>
        </div>
      </div>
    </div>
  )
}
